import { AlertCircle } from "lucide-react";
import React from "react";

interface ConfirmDialogProps {
  cancelText?: string;
  confirmText?: string;
  icon?: React.ReactNode;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  title?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  cancelText = "Cancel",
  confirmText = "Yes",
  icon,
  message,
  onCancel,
  onConfirm,
  open,
  title = "Confirm",
}) => {
  if (!open) return null;
  return (
    <div className="animate-fadeIn fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 transition-opacity duration-300">
      <div className="animate-slideUp mx-2 w-full max-w-md rounded-xl bg-white p-6 shadow-2xl dark:bg-gray-900 sm:mx-0">
        <div className="mb-4 flex items-center gap-3">
          {icon || (
            <AlertCircle className="h-7 w-7 text-red-500 dark:text-red-400" />
          )}
          <h2 className="text-xl font-bold text-gray-900 dark:text-gray-100">
            {title}
          </h2>
        </div>
        <p className="mb-6 break-words text-base text-gray-700 dark:text-gray-300">
          {message}
        </p>
        <div className="flex flex-col justify-end gap-2 sm:flex-row">
          <button
            className="rounded-lg bg-gray-200 px-4 py-2 text-gray-800 transition hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className="rounded-lg bg-red-600 px-4 py-2 font-semibold text-white transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease;
        }
        @keyframes slideUp {
          from { transform: translateY(40px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slideUp {
          animation: slideUp 0.25s cubic-bezier(.4,2,.3,1);
        }
      `}</style>
    </div>
  );
};

export default ConfirmDialog;
